export const DEFAULT_ROW_DATA = {
	newCustomers: {
		before: 0,
		after: 0,
	},
	lostCustomers: {
		before: 0,
		after: 0,
	},
	payingCustomers: {
		before: 0,
		after: 0,
	},
	mmr: {
		before: 0,
		after: 0,
	},
	revenueGenerated: {
		before: 0,
		after: 0,
	},
	totalInvestment: 0,
	totalProfit: 0,
	totalROI: 0,
}
